import PropTypes from 'prop-types';
import { Modal, Fade, Backdrop } from '@material-ui/core';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import TravelWitsLogo from '../../assets/svgs/travelwitsLogo.svg';
import useStyles from './styles';

const ModalSpinner = ({ isOpen, children, size, doHidelogo }) => {
  const classes = useStyles({ size });

  const { travelAgency } = useSelector((store) => store.user);

  const modalSpinnerImage =
    travelAgency && travelAgency.settings && travelAgency.settings.modalSpinnerImage;

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={clsx(classes.modal, 'sm:p-20 p-2')}
      open={isOpen}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={isOpen}>
        <div
          className={clsx(
            classes.paper,
            size === 'xs' ? 'h-1/3 sm:w-1/3 w-full' : 'min-h-1/2 sm:w-1/2 w-full',
          )}
        >
          {!doHidelogo &&
            (modalSpinnerImage ? (
              <img className="h-24 mb-4" src={modalSpinnerImage} alt="secondary agency logo" />
            ) : (
              <h2 className="text-theme">
                <TravelWitsLogo className={classes.logo} />
              </h2>
            ))}
          {children}
        </div>
      </Fade>
    </Modal>
  );
};

ModalSpinner.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  size: PropTypes.string,
  doHidelogo: PropTypes.bool,
};

ModalSpinner.defaultProps = {
  children: undefined,
  size: undefined,
  doHidelogo: false,
};

export default ModalSpinner;
